<template>
  <component
    :is="carouselStyleComponent(getCarouselComponentName)"
    :data="fetchData"
    :title="title"
    :settings="block.settings"
    :key="reRenderKey"
  >
    <template slot="slide-card" slot-scope="props">

      <block
        :class="getCarouselComponentName"
        :id="id"
        :data="props.item"
        :blockIndex="blockIndex"
        :sectionId="sectionId"
        :sectionTextColor="block.titleColor"
        :settings="block.settings"
        :css="block.settings.style"
        :uiBlockComponent="block.settings.component"
        :theme="theme"
      >
      </block>

    </template>
  </component>
</template>
<script>
  import VmCarousel from '@fremcast/section/VmCarousel';
  import section from '@fremcast/section/mixins/section';
  import presentation from '@fremcast/section/mixins/presentation';
  import video from '@fremcast/section/mixins/videos';
  export default {
    data() {
      return {
        reRenderKey: 1,
        carrouselComponents: {
          "Slider": "VmCarouselSimple",
          "Slider 3D": "VmCarousel3D",
          "SliderCoverFlow": "VmCarouselCoverFlow",
          "SliderMulti": "VmCarouselMulti"
        },
        getCarouselComponentName: 'VmCarouselSimple',
      };
    },
    mounted() {
      this.getCarouselComponentName = this.carrouselComponents[this.block.settings.presentation];
    },
    props: [
      'data'
    ],
    components: {
      VmCarousel,
      Block: () => import("./Block")
    },
    mixins: [
      section,
      presentation,
      video
    ],
    methods: {
      carouselStyleComponent(name) {
        return require(`@fremcast/section/${name}`).default;
      }
    },
    watch: {
      block: {
        handler: function (value) {
          this.getCarouselComponentName = this.carrouselComponents[value.settings.presentation];
          this.reRenderKey++;
        },
        deep: true
      }
    }
  }
</script>
